import React from 'react'
import styled from 'styled-components'

const ValidationMessage = (meta) => {
  if (meta.error && meta.touched) {
    return <Error className="field-error">{meta.error}</Error>
  }
  return null
}

const withValidation = (InputComponent) => (props) =>
  (
    <FieldContainer className="withValidation__container">
      <InputComponent
        {...props}
        {...props.input}
        {...props.selectProps}
        placeholder={props.placeholder}
        autoFocus={props.autoFocus}
      />
      <ValidationMessage {...props.meta} />
    </FieldContainer>
  )

export default withValidation

const FieldContainer = styled.div`
  position: relative;
  padding-bottom: 18px;
`

const Error = styled.span`
  color: #e44258;
  font-size: 12px;
  font-weight: 600;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: left;
  white-space: nowrap;
`
